import { isTextEntryTarget } from './isTextEntryTarget'

// Shared "A" contract for the two markup-visibility toggles (the Workflows map's
// own markups, the Precise Location modal's adjacent ones). One handler so the
// same keystroke can't drift into behaving differently on the two surfaces;
// isActive carries each surface's own gating.
export function createMarkupsVisibilityKeyHandler(opts: {
  isActive: () => boolean
  onToggle: () => void
}): (e: KeyboardEvent) => void {
  return e => {
    if (!opts.isActive() || e.defaultPrevented) {
      return
    }
    if (e.metaKey || e.ctrlKey || e.altKey) return
    if ((e.key || '').toLowerCase() !== 'a') return
    if (isTextEntryTarget(e.target)) {
      return
    }
    e.preventDefault()
    opts.onToggle()
  }
}
